<template>
	<div id="Container" class="widget-container background--card Container--max d-flex justify-content-center align-items-center">
        <a href="#" @click.prevent="closeSelf" class="close">
            <svg-rndr svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent">
            <div class="widget-contents__inner DialogContentInner">
                <div class=" d-flex justify-content-center mb-4">
                    <svg-rndr svg="check-circle-green.svg" :width="170" />
                </div>
                <div class="form-row justify-content-center mb-4">
                    <div class="col-md-auto">
                        <h1 v-translate>You've successfully cancelled the following subscription(s):</h1>

                        <ul>
                            <li v-for="subscription in cancelledSubscriptions">
                                {{ subscription.Name }} ${{ subscription.purchaseOption.Price__c }} {{ subscription.purchaseOption.Name }}
                            </li>
                        </ul>
                    </div>
                    
                </div>

                <div class="row justify-content-center align-items-end">
                    <div class="col-12 col-md text-center ml-md-auto">
                        <button class="btn btn-primary" @click.prevent="closeSelf" v-translate>Close</button>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <flash-message></flash-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import widgetMixin from '@M/widgets/dialog';

export default {
    mixins: [widgetMixin],

    mounted() {
        this.sendCancellationEmail(this.cancelledSubscriptions);
    },

    methods: {
        ...mapActions({
            sendCancellationEmail: 'Widget/sendCancellationEmail'
        }),
    },

    computed: {
        ...mapState('Widget', ['cancelSubscriptionsCheckboxes']),

        cancelledSubscriptions() {
            return this.subscriptions.filter(subscription => {
                if (typeof this.cancelSubscriptionsCheckboxes[subscription.subscriptionId] == 'undefined') {
                    return false;
                }

                return this.cancelSubscriptionsCheckboxes[subscription.subscriptionId];
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/CancelSubscriptionSuccess.vue